module.exports = __webpack_public_path__ + "img/aeroland-clinic-image-01.bd3e0d03.png";